import React from 'react';
import './style.scss';
import './themed.scss';

const Toggle = ({ isActive, handleToggle, left, right }) => {
  return (
    <label 
      className="toggle_indicator_container" 
      aria-label={ `Toggle ${ left } and ${ right }. ${ isActive ? left : right} is active` }
    >
      {`${ left } `}
      <button 
        type="button" 
        onClick={ handleToggle } 
        className="toggle_indicator" 
        data-state={ isActive ? 'left' : 'right' }
        >
      </button>
      {` ${ right }`}
    </label>
  )
}

export default Toggle